module.exports = __webpack_public_path__ + "static/img/main_prize.f48bd31.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/land/main_prize.png
// module id = BvDa
// module chunks = 1